import { queryOptions } from "@tanstack/react-query";
import * as notesApi from "@/lib/api/notes";
import { queryKeys } from "@/lib/query-keys";

export const homeNotesQueryOptions = (userId?: string) =>
  queryOptions({
    queryKey: queryKeys.notes.home(userId),
    queryFn: ({ signal }) => notesApi.fetchHomeNotes({ signal }),
    enabled: !!userId,
  });
